import { createEndpoint } from '@/shared/models/api';
import { IdValue } from '@/app/api/morgan-thermal';
import { CompanyInformation } from '@/app/api/morgan-thermal/company';

export type UserRole = IdValue;

export const getAvailableRoles = createEndpoint<UserRole[]>(({ fetch }) => (companyId: CompanyInformation['id']) => fetch(`/Configuration/GetAvailableRoles/${companyId}`));